module.exports = __webpack_public_path__ + "img/activity_entry.03c627c.png";